module.exports = __webpack_public_path__ + "static/media/IMG_8667.cbba87b6.jpeg";